/**
 * Route → label, plus an optional parent for routes that are reached from
 * somewhere other than their URL ancestor (the audit dashboard lives under
 * /admin but is entered from Settings, and had no way back).
 */
export interface BreadcrumbRoute {
  labelKey: string;
  parent?: string;
}

export const BREADCRUMB_ROUTES: Record<string, BreadcrumbRoute> = {
  '/dashboard': { labelKey: 'navigation.dashboard' },
  '/documents': { labelKey: 'navigation.documents' },
  '/documents/upload': { labelKey: 'navigation.uploadDocument', parent: '/documents' },
  '/search': { labelKey: 'navigation.search' },
  '/drbfm': { labelKey: 'navigation.drbfm' },
  '/drbfm/history': { labelKey: 'drbfm.history.title', parent: '/drbfm' },
  '/verification': { labelKey: 'navigation.verification' },
  '/cad-viewer': { labelKey: 'navigation.cadViewer' },
  '/settings': { labelKey: 'navigation.settings' },
  '/help': { labelKey: 'navigation.help' },
  '/admin': { labelKey: 'navigation.admin' },
  '/admin/settings': { labelKey: 'navigation.settings', parent: '/admin' },
  '/admin/activity': { labelKey: 'navigation.activityDashboard', parent: '/settings' },
  '/admin/anomalies': { labelKey: 'navigation.anomalies', parent: '/admin' },
};

export const BREADCRUMB_ROOT = '/dashboard';
